import dayjs from 'dayjs';

const numberFormatter = new Intl.NumberFormat( 'en-US', { style: 'decimal' } );
const SHORT_DATE_TOKEN = 'MM/DD/YYYY';
const LONG_DATE_TOKEN = 'dddd, MM/DD/YYYY, hh:mm A';

export const formatNumber = ( value ) => {
    if ( value === null || isNaN( value ) ) {
        return '0';
    }
    return numberFormatter.format( value );
};

export const formatDateShort = ( timestamp ) => {
    return dayjs( timestamp ).format( SHORT_DATE_TOKEN );
};

export const formatDateLong = ( timestamp ) => {
    return dayjs( timestamp ).format( LONG_DATE_TOKEN );
};